import { serializable, object, list } from 'serializr';
import { LocationModel } from './location.model';

export class ALLLocations {
  @serializable(list(object(LocationModel)))
  data?: LocationModel[];

  @serializable
  totalItems?: number;

  @serializable
  totalPages?: number;

  @serializable
  currentPage?: number;
}
